<template>
  <div v-if="mode === 'primary'" class="flex bg-gray-400 w-full rounded-3xl text-gray-200 ">
    <div v-for="(opt, index) in options" :key="opt + index" @click="selectOption(opt)"
      class="flex items-center justify-center text-center px-[10px] leading-10 cursor-pointer"
      :class="[selectedOption == opt ? 'text-white text-bold bg-blue rounded-3xl' : 'text-gray-900', `w-1/${options.length}`, customClasses]">
      {{ titles && titles[index] ? $t(titles[index]).tTitle() : $t(opt).tTitle() }}
    </div>
  </div>
  <div v-else-if="mode === 'secondary'" class="bg-transparent grid grid-flow-col gap-2">
    <div v-for="(opt, index) in options" :key="`sub-menu-routes-${index}`"
      class="cursor-pointer text-center text-sm text-blue px-3 py-2 min-w-[150px] rounded-3xl hover:bg-blue-100 whitespace-nowrap"
      :class="[{ 'bg-blue-200 font-bold': selectedOption == opt }, customClasses]" @click="selectOption(opt)">
      {{ titles && titles[index] ? $t(titles[index]).tTitle() : $t(opt).tTitle() }}
    </div>
  </div>
  <div v-else-if="mode === 'underline'" class="w-full flex gap-9 relative">
    <div v-for="(opt, index) in options" :key="opt + index" @click="selectOption(opt)"
      :class="[selectedOption == opt ? 'font-bold border-b-2 border-blue border-solid text-opacity-100' : 'text-opacity-70', customClasses]"
      class="text-blue pb-2.5 relative z-[1] cursor-pointer">
      {{ titles && titles[index] ? $t(titles[index]).tTitle() : $t(opt).tTitle() }}
    </div>
    <div class="absolute bottom-0 ltr:left-0 rtl:right-0 w-full border-b border-solid border-gray-300 z-0"></div>
  </div>
</template>

<script>
export default {
  name: "ButtonGroup",
  props: {
    mode: {
      type: String, // primary, secondary, underline
      default: "primary", // Default to 'primary' if not provided
    },
    selectedOption: String,
    options: {
      type: Array, // Array of strings ex: ["first", "second", "third"]
      require: true // Default to true if not provided
    },
    titles: {
      type: Array, // Array of strings used for custom title ex: ["first_title", "second_title", "third_title"]
      require: false
    },
    customClasses: String
  },
  computed: {},
  methods: {
    /**
     * Function to select the option clicked
     * @param option option selected
     */
    selectOption(option) {
      this.$emit("click", option)
    }
  }
};
</script>

<style scoped></style>
